// eslint-disable-next-line import/prefer-default-export
export const normalizePhone = (phone) =>
  parseInt(String(phone).replace(/\D+/g, ''), 10);
